export const noPicAvailableUrl = 'https://upload.wikimedia.org/wikipedia/commons/a/ac/No_image_available.svg';

//TODO make configurable
export const homebaseLocationData = {
    city: "helsinki",
    country: "Finland",
    lat: 60.317199707031,
    lng: 24.963300704956,
    continent: "europe",
    airportName: "helsinki vantaa airport",
    icao: "efhk",
    climate: 'Dfb'
};

export const GOOGLE_MAP_TYPE = -1;

export const climateTexts: { [key: string]: string; } = {
    'Af': 'Tropical rainforest',
    'Am': 'Tropical monsoon',
    'Aw': 'Tropical savanna',
    'As': 'Tropical savanna',
    'BW': 'Desert',
    'BS': 'Steppe',
    'Cfa': 'Subtropical',
    'Cfb': 'Oceanic',
    'Cfc': 'Subpolar oceanic',
    'Cwa': 'Subtropical',
    'Cwb': 'Subtropical highland',
    'Cwc': 'Subtropical highland',
    'Cs': 'Mediterranean',
    'Dfa': 'Continental',
    'Dfb': 'Continental',
    'Dfc': 'Subarctic',
    'Dfd': 'Subarctic',
    'Dwa': 'Continental',
    'Dwb': 'Continental',
    'Dwc': 'Subarctic',
    'Dwd': 'Subarctic',
    'Dsa': 'Mediterranean continental',
    'Dsb': 'Mediterranean continental',
    'Dsc': 'Mediterranean subarctic',
    'Dsd': 'Mediterranean subarctic',
    'ET': 'Tundra',
    'EF': 'Ice cap'
};

export const climateColors: { [key: string]: string; } = {
    'Ice cap':'#686868',
    'Tundra':'#B2B2B2',
    'Subarctic':'#007E7D',
    'Mediterranean subarctic':'#966495',
    'Continental':'#ABB1FF',
    'Mediterranean continental':'#FF00FE',
    'Steppe':'#F5A301',
    'Subpolar oceanic':'#33C701',
    'Oceanic':'#66FF33',
    'Desert':'#FE9695',
    'Subtropical highland':'#329633',
    'Subtropical':'#C6FF4E',
    'Mediterranean':'#C6C700',
    'Tropical savanna':'#46A9FA',
    'Tropical monsoon':'#0077FF',
    'Tropical rainforest':'#0000FE',
};

export const climateColors2 = function(climate: string): number {

    const numbers: { [key: string]: number; } = {
        'Ice cap': 1,
        'Tundra': 2,
        'Subarctic': 3,
        'Mediterranean subarctic': 4,
        'Continental': 5,
        'Mediterranean continental': 6,
        'Steppe': 7,
        'Subpolar oceanic': 8,
        'Oceanic': 9,
        'Desert': 10,
        'Subtropical highland': 11,
        'Subtropical': 12,
        'Mediterranean': 13,
        'Tropical savanna': 14,
        'Tropical monsoon': 15,
        'Tropical rainforest': 16
    };

    return (typeof numbers[climate] === 'undefined') ? 7 : numbers[climate];

};
